module.exports = __webpack_public_path__ + "static/media/aerial.2fa84dcf.svg";